import { createContext, useContext, useState, useEffect } from "react";

const BacAuthContext = createContext(null);

function leerSesion() {
  try {
    return JSON.parse(localStorage.getItem("bac_sesion") || "null");
  } catch {
    return null;
  }
}

export function BacAuthProvider({ children }) {
  const [sesion, setSesion] = useState(leerSesion());

  const login = (token, usuario) => {
    const datos = { token, usuario };
    localStorage.setItem("bac_sesion", JSON.stringify(datos));
    setSesion(datos);
  };

  const logout = () => {
    localStorage.removeItem("bac_sesion");
    setSesion(null);
  };

  // Este evento SOLO lo dispara axios.jsx cuando el servidor responde un
  // 401 real (token vencido/inválido confirmado, con conexión de por
  // medio) — nunca por quedarse sin internet. Ver el comentario en
  // axios.jsx para el detalle de esa distinción.
  useEffect(() => {
    const cerrarPorSesionInvalida = () => logout();
    window.addEventListener("bac-sesion-invalida", cerrarPorSesionInvalida);
    return () => window.removeEventListener("bac-sesion-invalida", cerrarPorSesionInvalida);
  }, []);

  return (
    <BacAuthContext.Provider value={{ usuario: sesion?.usuario || null, logueado: !!sesion, login, logout }}>
      {children}
    </BacAuthContext.Provider>
  );
}

export function useBacAuth() {
  return useContext(BacAuthContext);
}